export interface UpSellResponse {
  upsellOptions: UpSellOption[];
  upsellAvailableUntil: string;
  upsellId: string;
}

export interface UpSellOption {
  amount: UpSellAmount;
  families: UpSellFamily[] | UpSellFamily;
  optionId: number;
  isPreApproved?: boolean;
  breakRulesMessage?: string[];
}
interface UpSellAmount {
  currencyCode: string;
  fare: number;
  taxes: number;
}

interface UpSellFamily {
  code: string;
  name: string;
  inclusions: UpSellInclusion[] | UpSellInclusion;
}

export interface UpSellInclusion {
  rowName: string;
  code: string;
  type: UpSellInclusionType | string;
  title?: string;
  subTitle?: string;
  order: number;
}

export enum UpSellInclusionType {
  Included = 'Included',
  AtCharge = 'AtCharge',
  NotOffered = 'NotOffered',
}
